import RestRequest from "../tool/RestRequest";
import config from "../config";

export default class BasketService {
    static plus(productId, count) {

        let postParams = new FormData();
        postParams.append('count', count);
        postParams.append('productId', productId);

        return RestRequest.update(config.restBasket, productId, {
            body: postParams,
        });
    }

    static minus(productId, count) {

        let postParams = new FormData();
        postParams.append('count', count);
        postParams.append('productId', productId);

        return RestRequest.update(config.restBasket, productId, {
            body: postParams,
        });
    }

    static remove(productId) {
        return RestRequest.delete(config.restBasket, productId);
    }
}